import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { ButtonsContainer, ButtonContainer } from "./ColdStartButtonsStyles";
import ColdStartButton from "./ColdStartButton/ColdStartButton";
import {
  selectPatternIds,
  clearDrawingArea,
} from "../../../../redux/slices/coldStart";
import Button from "../../../UI/Button/CustomButtonRed";

export default function ColdStartButtons() {
  // Redux dispatch function
  const dispatch = useDispatch();

  // Select from redux store
  const patternsIds = useSelector(selectPatternIds);

  return (
    <ButtonsContainer>
      <ButtonContainer>
        <ColdStartButton noPatterns={!patternsIds.length} />
      </ButtonContainer>
      <ButtonContainer>
        <Button
          onClick={() => dispatch(clearDrawingArea())}
          disabled={!patternsIds.length}
        >
          Clear
        </Button>
      </ButtonContainer>
    </ButtonsContainer>
  );
}
